import { render, staticRenderFns } from "./BrowserUnsupportedModal.vue?vue&type=template&id=08ed43cc&scoped=true&"
import script from "./BrowserUnsupportedModal.vue?vue&type=script&lang=ts&"
export * from "./BrowserUnsupportedModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ed43cc",
  null
  
)

export default component.exports